
import EntregasTable from "../Entregas/EntregasTable"
import Pecas from "../Peças/Pecas"
import Obra from "./newObra"
import ObraAnexos from "./ObraAnexos"


export default function ObraWrapper() {




    return(<>
        <Obra/>
       
        <div>
            <EntregasTable/>
        </div>

        <div>
            <Pecas/>
        </div>

        <div>
            <ObraAnexos/>
        </div>
       
    </>)


}